/**
 * SlideWrapper
 *
 * Provides consistent layout and styling around each slide.
 * Pulls styles from `slideConfig` so all slides look cohesive.
 */
import React from "react";
import { Box } from "@mui/material";
import { getSlideStyles } from "./slideConfig";

/**
 * SlideWrapper Component
 *
 * Provides consistent styling and layout for all slides in the kiosk slideshow.
 * This centralizes slide styling and makes maintenance easier.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The slide content
 * @param {string} props.slideType - Type of slide (intro, announcement, map, station)
 * @param {Object} props.sx - Additional custom styles
 * @returns {JSX.Element} The wrapped slide component
 */
export default function SlideWrapper({
  children,
  slideType,
  sx = {},
  ...props
}) {
  // Get styles from centralized configuration
  const slideStyles = getSlideStyles(slideType, sx);

  return (
    <Box {...props} sx={slideStyles}>
      {children}
    </Box>
  );
}
